import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';

import * as S from './CompanyCell.styles';

interface CompanyCellProps {
  entity: Entity;
}

export const CompanyCell = ({ entity }: CompanyCellProps) => {
  return (
    <S.Root>
      <AssetLogoContainer entity={entity} size={32} />
      <S.FlexColumn>
        <S.TitleLabel>{entity.name_short || entity.name}</S.TitleLabel>
        <S.SubtitleLabel>{formatTicker(entity)}</S.SubtitleLabel>
      </S.FlexColumn>
    </S.Root>
  );
};
